import jQuery from 'jquery';
import { subscriptionTypes, getSessionStatus } from 'rp-auth';
import { trackBarrierInteraction, TRAIT_SELECTION } from 'rp-analytics';
import { TRAIT_SUBSECTION } from 'rp-analytics/lib/traits';

const { FREE, ESSENTIAL, ULTIMATE } = subscriptionTypes;

const selector = {
    link: '.js-form-hoverLink',
    row: '.js-form-row',
    loginLinks: '.loginLink',
    subscribeLinks: '.subscribeLink',
    freeTrial: '.freeTrial'
};
const hoverClass = 'RC-runnerForm__row_hover';

const subsectionTrait = { [TRAIT_SUBSECTION]: 'Races' };

const handleLoginClick = () => {
    trackBarrierInteraction({
        [TRAIT_SELECTION]: 'Login',
        ...subsectionTrait
    });
};

const handleSubscribeOrUpgradeClick = (e) => {
    const buttonText = e.target.innerHTML.replace(/[\n\t]/g, '').trim();
    trackBarrierInteraction({
        [TRAIT_SELECTION]: buttonText,
        ...subsectionTrait
    });
};

const showBarrier = () => {
    // Set login links
    const backUrl = `${window.location.href}`;
    const encodedBackUrl = btoa(backUrl);
    const loginHref = `/api/auth/login/?state=${encodedBackUrl}&force=true`;
    const signupHref = `/api/auth/login/?signup=true&state=${btoa(window.location.href)}&force=true`;

    jQuery(selector.loginLinks).each((_, element) => {
        jQuery(element).attr('href', loginHref);
        element.addEventListener('click', handleLoginClick);
    });

    jQuery(selector.subscribeLinks).each((_, element) => {
        element.addEventListener('click', handleSubscribeOrUpgradeClick);
    });

    jQuery(selector.freeTrial).each((_, element) => {
        jQuery(element).attr('href', signupHref);
    });
};

// eslint-disable-next-line consistent-return
const form = () => {
    const subscriptionLevelText = jQuery('#subscription-level');
    let subscriptionLevel = '';
    if (subscriptionLevelText) subscriptionLevel = subscriptionLevelText.text().trim();

    if (subscriptionLevel === ESSENTIAL || subscriptionLevel === ULTIMATE) {
        return false;
    }

    if (subscriptionLevel !== FREE) {
        jQuery(selector.subscribeLinks).each((_, element) => {
            jQuery(element).text('Upgrade');
        });
    }

    jQuery(document).on('mouseenter', selector.link, ({ target }) => {
        jQuery(target).closest(selector.row).addClass(hoverClass);
    });

    jQuery(document).on('mouseleave', selector.link, ({ target }) => {
        jQuery(target).closest(selector.row).removeClass(hoverClass);
    });

    // Mock sessions
    // const sessionMock = () => new Promise((resolve) => { resolve({ session: true }); });

    // Wrap getSessionStatus in a new Promise
    /* eslint-disable no-shadow */
    new Promise((resolve) => {
        const sessionStatus = getSessionStatus();
        resolve(sessionStatus);
    })
        .then((sessionStatus) => {
            showBarrier();
            const { session } = sessionStatus;

            // If the user is not logged in
            if (!session) {
                return;
            }

            if (session) {
                // Hide login for tipping, and show Upgrade instead of Subscribe
                jQuery(selector.loginLinks).each((_, element) => {
                    jQuery(element).css('display', 'none');
                });
            }
        })
        .catch((e) => {
            // If session is expired, the promise throws an error and we show barriers
            showBarrier();
            console.error(e);
        });
    /* eslint-enable no-shadow */
};

export default form;



// WEBPACK FOOTER //
// ./lib/js/modules/form/form.js